module.exports = __webpack_public_path__ + "img/alarm-fridge.8e1e23bb.jpg";